import React from "react"

import ModalV4 from "../../../app/ui/modal/v4/v4"
import ModalAddUserPortfolioUsersForm from "./add-portfolio-users-form/add-portfolio-users-form"
import {PortfolioUserAccess} from "../../gd/const/portfolio"

class ModalAddPortfolioUser extends ModalV4 {

    state = {
        search  : '',
        selected: []
    }

    constructor(props) {
        super(props)

        // precalculate potential users...
        this.existingUsers = []
        this.companyUsers = []

        if (props.params.users) this.existingUsers = props.params.users;

        gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId).map(cu=>{
            if (!this.existingUsers.includes(cu.user.id)) {
                this.companyUsers.push(cu)
            }
        })

        // sort by name
        this.companyUsers = _.sortBy(this.companyUsers,(cu=>cu.user.name))
    }

    canSubmit = () => this.state.selected && this.state.selected.length > 0

    onUserClick = (userId) => {
        const newSelected = this.state.selected.slice()
        const existingKey = _.findIndex(newSelected, obj => obj.userId === userId)

        if (existingKey !== -1) {
            newSelected.splice(existingKey,1);
        } else {
            newSelected.push({
                userId  : userId,
                access    : PortfolioUserAccess.STANDARD
            })
        }

        this.setState({
            selected: newSelected
        })
    }

    onSubmit() {
        this.props.params.onSubmit.call(this.props.params.this,this.state.selected)
    }

    onClickSubmit = (e) => {
        e.stopPropagation()
        this.onSubmit()
    }

    onSearchCancel = () => {
        this.setState({search: ''})
    }

    onSearchChange = (event) => {
        this.setState({search: event.target.value ? event.target.value : ''})
    }

    onRoleSelect = (userId, access) => {
        const selected = this.state.selected

        selected.map(item=>{
            if (item.userId === userId) item.access = access
        })

        this.setState({
            selected: selected
        })
    }

    render() {
        return <ModalAddUserPortfolioUsersForm search           = {this.state.search}
                                               companyUsers     = {this.companyUsers}
                                               selected         = {this.state.selected}
                                               canSubmit        = {this.canSubmit()}
                                               onClickSubmit    = {this.onClickSubmit}
                                               onUserClick      = {this.onUserClick}
                                               onRoleSelect     = {this.onRoleSelect}
                                               onSearchChange   = {this.onSearchChange}
                                               onSearchCancel   = {this.onSearchCancel}
                                               closeModal       = {this.closeModal}/>
    }
}

module.exports = ModalAddPortfolioUser